import { useMutation, useQueryCache } from 'react-query';
import { addDoctors } from 'src/services/api/users';

function useAddDoctors() {
  const queryCache = useQueryCache();

  return useMutation(({ user, data }) => addDoctors(user, data), {
    onSuccess: (data) => queryCache.setQueryData(['user', data.data?.id], data),
  });
}

export default useAddDoctors;
